import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';
import { Link } from 'react-router-dom';

const BusinessProcess = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Business Process"
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                    />
                    <div class="inner-container">
                        <h2>Business Process</h2>
                        <h3>
                            <Link to="/services/business-process/erp-automation">ERP Automation</Link>
                        </h3>
                        <p>An all in one platform that would automate any aspect of your business process be it finance, inventory, supply chain, sales, purchasing, human resources, customer relationship management, & so on.</p>
                        <p>Expand globally, run operations with ease using our integrated unified platform that seamlessly automates complex process of your enterprise.</p>
                        <h3>
                            <Link to="/services/business-process/hospital-information-system">Hospital Information System</Link>
                        </h3>
                        <p>Simplify workflow patterns of your hospital by digitizing the complete operations and increase the overall satisfaction of the patient</p>
                        <p>Built with a futuristic vision we work closely in line with our clients to design solutions that can be integrated seamlessly into the existing healthcare systems</p>
                        <h3>
                            <Link to="/services/business-process/human-resource-management-information-system">Human Resource Management Information System</Link>
                        </h3>
                        <p>Standardize your HR tasks and processes and offer a more seamless, streamlined, and efficient coordination between employees and the organization.</p>
                        <p>Automate your HR activities right from hiring, flawless digital onboarding, talent development, employee engagement and build robust workplace at every touchpoint.</p>
                        <h3>
                            <Link to="/services/business-process/sales-process-automation">Sales Process Automation</Link>
                        </h3>
                        <p>Sales Process Automation</p>
                        <h3>
                            <Link to="/services/business-process/billing-accounts-process-automation">Billing & Accounts Process Automation</Link>
                        </h3>
                        <p>Don’t allow your current manual process to increase the risk of financial leaks. Centralise your billing and payment process from invoice creation to payment collection and get paid faster.</p>
                        <p>Automation makes it easier to track the organisational financial performance and enables financial planning.</p>
                        <h3>
                            <Link to="/services/business-process/shopping-cart">Shopping Cart</Link>
                        </h3>
                        <p>Build a robust store in line with your niche. We possess ingenious expertise to develop solutions that precisely reflect your business needs. Made using the state of art technologies we offer seamless navigation to users</p>
                        <h3>
                            <Link to="/services/business-process/supply-chain-process">Supply Chain Process</Link>
                        </h3>
                        <p>We tailor your supply chain strategy to meet your needs. Optimize procurement management, enhance process transparency while saving on time and resources.</p>
                        <h3>
                            <Link to="/services/business-process/job-portal">Job Portal</Link>
                        </h3>
                        <p>Simplify your job search with the finest designed job portals. We make it easier for your professionals and recruitment team to interact with one another and help you hire the best fit.</p>
                        <h3>
                            <Link to="/services/business-process/location-based-services">Location Based Services</Link>
                        </h3>
                        <p>We use real time geo location data to provide information or extend services to the users. Our solutions integrate data from any kind of resources be it GPS, QR codes and RFID technology</p>
                        <h3>
                            <Link to="/services/business-process/event-management-webinars">Event Management & Webinars</Link>
                        </h3>
                        <p>Our solutions deliver not just a virtual learning experience but a real interaction among learners. You can facilitate discussions using our virtual tools like whiteboard, breakout rooms, chatbox, polling, Q & A session.</p>
                        <h3>
                            <Link to="/services/business-process/social-networking">Social Networking</Link>
                        </h3>
                        <p>Get the best social network development services for your business fully customized to your niche in line with technology standards.</p>
                        <p>We incorpate technology mediated social interactions to our development practices, and techniques thereby adding a social dimension to customer interactions.</p>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default BusinessProcess;